<template>
  <section class="content_section">
    <!-- Loading overlay for delete operations -->
    <div v-if="isDeleting" class="delete-loading-overlay">
      <md-progress-spinner md-mode="indeterminate"></md-progress-spinner>
      <span class="loading-text">{{ options.Lang?.deleting || 'Deleting...' }}</span>
    </div>

    <SimpleList
        v-if="isLoaded"
        :serverside="false"
        :data="yourData"
        :options="options"
        :wide="25"
        :title="options.Lang.passolution.title || 'Passolution'"
        :defaultCount="defaultCount"
        :cols="cols"
        :hideCols="hideCols"
        :emptyState="options.Lang.NoData || 'No Data Available'"
        :actions="actions"
        :clean="false"
        @updateData="getAllData()"
    />

    <!-- Edit Modal -->
    <editLink
        @updateData="getAllData()"
        v-if="options.showEditPassolutionForm && options.user.loggedIn"
        :currentItem="options.currentItem"
        :options="options"
    />
  </section>
</template>

<script>
import SimpleList from "@/components/lists/SimpleList";
import editLink from "@/components/dialogs/editPassolutionLink";

export default {
  name: 'Passolutions',
  props: {
    options: {
      type: Object,
      required: true
    }
  },
  components: {
    SimpleList,
    editLink
  },
  data() {
    return {
      yourData: [],
      defaultCount: 20, // How many items to show initially
      isLoaded: false,
      isDeleting: false, // Add loading state for delete operations
      // Define your table columns
      cols: ['trip_id', 'name', 'link', 'params', 'createdAt', 'status'],
      hideCols: ['params', 'name', 'createdAt'],
      actions: [
        {
          icon: 'edit',
          iconMaterial: true,
          action: 'editPassolutionLink',
          title: this.options.Lang.Edit || 'Edit'
        },
        {
          icon: 'delete',
          iconMaterial: true,
          action: 'deletePassolutionLink',
          title: this.options.Lang.Delete || 'Delete'
        }
      ]
    };
  },
  async created() {
    if (!this.options.hasOwnProperty('showEditPassolutionForm')) {
      this.$set(this.options, 'showEditPassolutionForm', false);
    }
    if (!this.options.hasOwnProperty('currentItem')) {
      this.$set(this.options, 'currentItem', null);
    }
    await this.getAllData();
  },
  async mounted() {
    this.isLoaded = true;
  },
  methods: {
    async getAllData() {
      let self = this;
      self.isLoaded = false;
      self.options.isUploading = true;

      await this.doPost({
        userdata: self.options.user
      }, 'passolution/getData', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          self.responseToTableData(res.data.data, self.cols).then(values => {
            self.yourData = values;
          });
        }
        self.options.isUploading = false;
        window.setTimeout(function () {
          self.isLoaded = true;
        }, 500);
      });
    },

    editPassolutionLink(item) {
      // Set the current item for editing
      this.options.currentItem = item;
      this.options.showEditPassolutionForm = true;
    },

    async deletePassolutionLink(item) {
      // Show confirmation dialog
      const confirmed = confirm(this.options.Lang?.confirmDelete || 'Are you sure you want to delete this item?');
      if (!confirmed) return;

      let self = this;
      self.isDeleting = true; // Start loading state

      try {
        await this.doPost({
          userdata: self.options.user,
          data: { id: item.id || item._id }
        }, 'passolution/deleteEntry', function (res) {
          if (res.data.error || res.data.status === 'error') {
            // Handle error
            if (res.data?.message) {
              self.options.errorMsg = self.$t(res.data.message);
              self.options.showError = true;
            }
            self.help.log(self.$t(res.data.msg || 'Delete failed'), false, true);
          } else {
            // Success - show success message and refresh data
            self.options.showSuccess = true;
            self.help.log(self.options.Lang?.deleteSuccess || 'Item deleted successfully', true);
            // Refresh the data list
            self.getAllData();
          }
        });
      } catch (error) {
        console.error('Delete error:', error);
        self.help.log(self.options.Lang?.deleteError || 'Failed to delete item', false, true);
      } finally {
        self.isDeleting = false; // End loading state
      }
    }
  }
};
</script>

<style scoped>
.delete-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.loading-text {
  margin-left: 10px;
  font-size: 16px;
  color: #333;
}
</style>
